<template>
  <div>
    <br>
    <legend v-if="this.getKey('tipo_dec') === 'Final'">Datos del encargo que concluye.</legend>
    <legend v-if="this.getKey('tipo_dec') != 'Final'">Datos del encargo actual.</legend>
    <div class="row">
      <div class="col-md-6 form-group" v-if="mostrarCampos">
        <label class="control-label">
          Nivel/Orden de Gobierno:
        </label>
        <br>
        <el-select clearable class="select-default" placeholder="Nivel" name="nivel_orden" v-validate="modelValidations.nivel_orden" v-model="model.nivel_gobierno_id">
          <el-option v-for="option in niveles" class="select-default" :value="option.id" :label="option.valor" :key="option.codigo">
          </el-option>
        </el-select>
        <small class="text-danger" v-show="nivel_orden.invalid">
          {{ getError('nivel_orden') }}
        </small>
      </div>

      <div class="col-md-6 form-group" v-if="mostrarCampos">
        <label class="control-label">
          Ámbito público
          <!--Poder/Naturaleza jurídica-->
        </label><br>
        <el-select clearable class="select-default" placeholder="Poder" name="poder" v-validate="modelValidations.poder" v-model="model.poder_juridico_id">
          <el-option v-for="option in poderes" class="select-default" :value="option.id" :label="option.valor" :key="option.codigo">
          </el-option>
        </el-select>
        <small class="text-danger" v-show="poder.invalid">
          {{ getError('poder') }}
        </small>
      </div>

      <div class="col-md-12 form-group">
        <label class="control-label">
          Nombre del ente público
        </label><br>
        <el-select disabled clearable class="select-default" filterable name="ente" v-validate="modelValidations.ente" placeholder="Nombre del ente público" v-model="model.ente_publico_id" disabled>
          <el-option v-for="option in entes" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
          </el-option>
        </el-select>
        <small class="text-danger" v-show="ente.invalid">
          {{ getError('ente') }}
        </small>
      </div>


    </div>
    <div class="row">
      <div class="col-md-3 form-group">
        <label class="control-label">
          Área
        </label>
        <br>
        <input class="form-control" type="text" name="area" v-validate="modelValidations.area" v-model="model.area_adscripcion" placeholder="Area de adscripción" disabled/>
        <small class="text-danger" v-show="area.invalid">
          {{ getError('area') }}
        </small>
      </div>
      <div class="col-md-3 form-group">
        <label class="control-label">
          Empleo, Cargo o Comisión
        </label>
        <br>
        <input class="form-control" type="text" name="nombre_cargo" v-validate="modelValidations.nombre_cargo" v-model="model.empleo_cargo_comision" placeholder="Nombre del Cargo" disabled/>
        <small class="text-danger" v-show="nombre_cargo.invalid">
          {{ getError('nombre_cargo') }}
        </small>
      </div>
      <div class="col-md-3 form-group">
        <label class="control-label">
          ¿ Está contratado por honorarios?
        </label><br>
        <p-radio name="honorarios" v-validate="modelValidations.honorarios" v-model="model.contratado_honorarios" label="1">SI</p-radio>
        <p-radio name="honorarios" v-validate="modelValidations.honorarios" v-model="model.contratado_honorarios" label="2">NO</p-radio>
        <small class="text-danger" v-show="honorarios.invalid">
          {{ getError('honorarios') }}
        </small>
      </div>
      <div class="col-md-3 form-group">
        <label class="control-label">
          Nivel del empleo, cargo o comisión
        </label>
        <br>
        <input class="form-control" type="text" name="nivel" v-validate="modelValidations.nivel" v-model="model.nivel_encargo" placeholder="Nivel" disabled/>
        <small class="text-danger" v-show="nivel.invalid">
          {{ getError('nivel') }}
        </small>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 form-group">
        <label class="control-label">
          Especifique funcion principal:
        </label>
        <el-select clearable multiple class="select-default" v-model="model.funcionesp" width="100%" name="funciones" v-validate="modelValidations.funciones" placeholder="Multiple Select">
          <el-option v-for="option in funciones_p" class="select-default" :value="option.id" :label="option.valor" :key="option.codigo">
          </el-option>
        </el-select>
        <small class="text-danger" v-show="funciones.invalid">
          {{ getError('funciones') }}
        </small>
      </div>
      <div class="col-md-8">
        <div class="form-group">
          <label class="control-label">
            Otras funciones:
          </label>
          <input class="form-control" type="text" name="cargopuesto" v-model="model.otras_funciones" placeholder="Otras funciones" />
        </div>
      </div>

      <div class="col-md-6 form-group">
        <label class="control-label">
          Fecha de toma de Posesión del empleo, cargo o comisión
        </label>
        <br>
        <el-date-picker :disabled="deshabilitado()" name="toma_posesion" value-format="dd-MM-yyyy" format="dd-MM-yyyy" v-validate="modelValidations.toma_posesion" v-model="model.fecha_posesion" :picker-options="opciones" type="date" placeholder="Selecciona">
        </el-date-picker>
        <small class="text-danger" v-show="toma_posesion.invalid">
          {{ getError('toma_posesion') }}
        </small>
      </div>
      <div class="col-md-4 form-group">
        <label class="control-label">
          Teléfono Laboral
        </label>
        <input class="form-control" type="text" name="curp" v-model="model.telefono_laboral_numero" placeholder="Teléfono Laboral" />
      </div>
      <div class="col-md-2 form-group">
        <label class="control-label">
          Ext
        </label>
        <input class="form-control" type="text" name="curp" v-model="model.telefono_laboral_extension" placeholder="Teléfono Laboral" />
      </div>
    </div>

    <domicilio v-model="n_domicilio" titulo=" del empleo, cargo o comisión "></domicilio>
    <br><br>

    <br>



    <div class="container">
      <div class="row" v-if="!add_item">
        <div class="form-group col-md-12">
          <div class="col-12 alert alert-info mb-0">
            <legend class="m-0">¿CUENTA CON OTRO EMPLEO, CARGO O COMISIÓN EN EL SERVICIO PÚBLICO DISTINTO AL DECLARADO? </legend>
          </div>
        </div>
        <div class="form-group col-12">
          <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
          <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
        </div>
      </div>
      <div v-if="bandera == '1'">
        <div>
          <br>

          <legend>Datos del encargo.</legend>
          <div class="row">
            <div class="col-md-6 form-group" v-if="mostrarCampos">
              <label class="control-label">
                Nivel/Orden de Gobierno:
              </label>
              <br>
              <el-select clearable class="select-default" placeholder="Nivel" name="nivel_orden2" v-validate="modelValidations2.nivel_orden2" v-model="model2.nivel_gobierno_id">
                <el-option v-for="option in niveles" class="select-default" :value="option.id" :label="option.valor" :key="option.codigo">
                </el-option>
              </el-select>
              <small class="text-danger" v-show="nivel_orden2.invalid">
                {{ getError('nivel_orden2') }}
              </small>
            </div>

            <div class="col-md-6 form-group" v-if="mostrarCampos">
              <label class="control-label">
                Ámbito público
                <!--Poder/Naturaleza jurídica-->
              </label><br>
              <el-select clearable class="select-default" placeholder="Poder" name="poder2" v-validate="modelValidations2.poder2" v-model="model2.poder_juridico_id">
                <el-option v-for="option in poderes" class="select-default" :value="option.id" :label="option.valor" :key="option.codigo">
                </el-option>
              </el-select>
              <small class="text-danger" v-show="poder2.invalid">
                {{ getError('poder2') }}
              </small>
            </div>

            <div class="col-md-12 form-group">
              <label class="control-label">
                Nombre del ente público
              </label><br>
              <el-select clearable class="select-default" filterable name="ente2" v-validate="modelValidations2.ente2" placeholder="Nombre del ente público" v-model="model2.ente_publico_id" :disabled="false">
                <el-option v-for="option in entes" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
                </el-option>
              </el-select>
              <small class="text-danger" v-show="ente2.invalid">
                {{ getError('ente2') }}
              </small>
            </div>


          </div>
          <div class="row">
            <div class="col-md-3 form-group">
              <label class="control-label">
                Área
              </label>
              <br>
              <input class="form-control" type="text" name="area2" v-validate="modelValidations2.area2" v-model="model2.area_adscripcion" placeholder="Area de adscripción" />
              <small class="text-danger" v-show="area2.invalid">
                {{ getError('area2') }}
              </small>
            </div>

            <div class="col-md-3 form-group">
              <label class="control-label">
                Empleo, Cargo o Comisión
              </label>
              <br>
              <input class="form-control" type="text" name="nombre_cargo2" v-validate="modelValidations2.nombre_cargo2" v-model="model2.empleo_cargo_comision" placeholder="Nombre del Cargo" />
              <small class="text-danger" v-show="nombre_cargo.invalid">
                {{ getError('nombre_cargo2') }}
              </small>
            </div>
            <div class="col-md-3 form-group">
              <label class="control-label">
                ¿ Está contratado por honorarios?
              </label><br>
              <p-radio name="honorarios2" v-validate="modelValidations2.honorarios2" v-model="model2.contratado_honorarios" label="1">SI</p-radio>
              <p-radio name="honorarios2" v-validate="modelValidations2.honorarios2" v-model="model2.contratado_honorarios" label="2">NO</p-radio>
              <small class="text-danger" v-show="honorarios2.invalid">
                {{ getError('honorarios2') }}
              </small>
            </div>
            <div class="col-md-3 form-group">
              <label class="control-label">
                Nivel del empleo, cargo o comisión
              </label>
              <br>
              <input class="form-control" type="text" name="nivel2" v-validate="modelValidations2.nivel2" v-model="model2.nivel_encargo" placeholder="Nivel" />
              <small class="text-danger" v-show="nivel.invalid">
                {{ getError('nivel2') }}
              </small>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 form-group">
              <label class="control-label">
                Especifique funcion principal:
              </label>
              <el-select clearable multiple class="select-default" v-model="model2.funciones" width="100%" name="funciones2" v-validate="modelValidations2.funciones2" placeholder="Multiple Select">
                <el-option v-for="option in funciones_p" class="select-default" :value="option.id" :label="option.valor" :key="option.codigo">
                </el-option>
              </el-select>
              <small class="text-danger" v-show="funciones2.invalid">
                {{ getError('funciones2') }}
              </small>
            </div>
            <div class="col-md-8">
              <div class="form-group">
                <label class="control-label">
                  Otras funciones:
                </label>
                <input class="form-control" type="text" name="cargopuesto" v-model="model2.otras_funciones" placeholder="Otras funciones" />
              </div>
            </div>

            <div class="col-md-6 form-group">
              <label class="control-label">
                Fecha de toma de Posesión del empleo, cargo o comisión
              </label>
              <br>
              <el-date-picker name="toma_posesion2" value-format="dd-MM-yyyy" format="dd-MM-yyyy" v-validate="modelValidations2.toma_posesion2" v-model="model2.fecha_posesion" :picker-options="opciones" type="date" placeholder="Selecciona">
              </el-date-picker>
              <small class="text-danger" v-show="toma_posesion2.invalid">
                {{ getError('toma_posesion2') }}
              </small>
            </div>
            <div class="col-md-4 form-group">
              <label class="control-label">
                Teléfono Laboral
              </label>
              <input class="form-control" type="text" name="tellab2" v-model="model2.telefono_laboral_numero" placeholder="Teléfono Laboral" />
            </div>
            <div class="col-md-2 form-group">
              <label class="control-label">
                Ext
              </label>
              <input class="form-control" type="text" name="telext2" v-model="model2.telefono_laboral_extension" placeholder="Teléfono Laboral" />
            </div>
          </div>

          <domicilio v-model="n_domicilio2" titulo=" del empleo, cargo o comisión "></domicilio>



        </div>
      </div>
    </div>
  </div>

</template>
<script>
  import {
    Tag,
    Select,
    DatePicker
  } from "element-ui";

  import {
    mapFields
  } from "vee-validate";

  import Domicilio from "../Domicilio.vue";

  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      Domicilio
    },
    computed: {
      ...mapFields([
        "correo_laboral",
        "ente",
        "nombre_cargo",
        "nivel",
        "poder",
        "honorarios",
        "nivel_orden",
        "area",
        "toma_posesion",
        "sector",
        "funciones",
        "ambitoexp",
        "nombreins",
        "unidadadm",
        "jerarqexp",
        "fechaingreso",
        "sectorexp",
        "cargopuesto",
        "correo_laboral2",
        "ente2",
        "nombre_cargo2",
        "nivel2",
        "poder2",
        "honorarios2",
        "nivel_orden2",
        "area2",
        "toma_posesion2",
        "sector2",
        "funciones2",
        "ambitoexp2",
        "nombreins2",
        "unidadadm2",
        "jerarqexp2",
        "fechaingreso2",
        "sectorexp2",
        "cargopuesto2"
      ])
    },
    data() {
      return {
        opciones: {
          disabledDate(date) {
            return date > new Date();
          }
        },
        add_item: false,
        // grupo: null,
        mostrarCampos: false,
        ip_id: null,
        datePicker: "",
        poderes: {},
        niveles: {},
        funcionesArr: [],
        funcionesExpArr: [],
        list_experiencia: [],
        edit_item: null,
        add_item: false,
        entidadFed: null,
        municipios: null,
        localidades: null,
        localidad: null,
        entes: {},
        ambitos: {},
        funciones_p: {},
        sectores: {},
        bandera: '0',
        model: {
          fecha_posesion: ''
        },
        model2: {
          contratado_honorarios: "2",
        },
        n_domicilio: {
          pais_id: 150, // México
          entidadF: 11, // Estado Guanajuato
          municipio: '',
          localidad: '',
          cp: '',
          colonia: '',
          vialidad: '',
          vialidad_nombre: '',
          ext: '',
          int: '',
        },
        n_domicilio2: {
          pais_id: 150, // México
          entidadF: 11, // Estado Guanajuato
          municipio: '',
          localidad: '',
          cp: '',
          colonia: '',
          vialidad: '',
          vialidad_nombre: '',
          ext: '',
          int: ''
        },
        modelValidations: {
          correo_laboral: {
            email: true
          },
          ente: {
            required: true
          },
          nombre_cargo: {
            required: true
          },
          nivel: {
            required: true
          },
          poder: {
            required: true
          },
          honorarios: {
            required: true
          },
          nivel_orden: {
            required: true
          },
          area: {
            required: true
          },
          toma_posesion: {
            required: true
          },
          sector: {
            required: true
          },
          funciones: {
            required: true
          }
        },
        modelValidations2: {
          correo_laboral2: {
            email: true
          },
          ente2: {
            required: true
          },
          nombre_cargo2: {
            required: true
          },
          nivel2: {
            required: true
          },
          poder2: {
            required: true
          },
          honorarios2: {
            required: true
          },
          nivel_orden2: {
            required: true
          },
          area2: {
            required: true
          },
          toma_posesion2: {
            required: true
          },
          sector2: {
            required: true
          },
          funciones2: {
            required: true
          }
        },
        fields_list: [
          "acciones",
          {
            key: "ambito_id",
            label: "Ámbito",
            tdClass: "text-left"
          },
          {
            key: "nivel_gobierno_id",
            label: "Nivel",
            tdClass: "text-left"
          },
          {
            key: "poder_ente_id",
            label: "Poder Jurídico",
            tdClass: "text-left"
          },
          {
            key: "nombre_institucion",
            label: "Nombre",
            tdClass: "text-left"
          },
          {
            key: "unidad_administrativa",
            label: "Unidad",
            tdClass: "text-left"
          },
          {
            key: "sector_industria_id",
            label: "Sector/Industria",
            tdClass: "text-left"
          },
          {
            key: "jerarquia_rango",
            label: "Jerarquia",
            tdClass: "text-left"
          },
          {
            key: "cargo_puesto",
            label: "Cargo/Puesto",
            tdClass: "text-left"
          },
          {
            key: "fecha_ingreso",
            label: "Fecha Ingreso",
            tdClass: "text-left"
          },
          {
            key: "fecha_salida",
            label: "Fecha Salida",
            tdClass: "text-left"
          },
          {
            key: "direccion_pais_id",
            label: "País",
            tdClass: "text-left"
          },
          {
            key: "direccion_entidad_federativa_id",
            label: "Entidad Federativa",
            tdClass: "text-left"
          },
          {
            key: "direccion_municipio_id",
            label: "Municipio",
            tdClass: "text-left"
          },
          {
            key: "direccion_cp",
            label: "CP",
            tdClass: "text-left"
          },
          {
            key: "direccion_numext",
            label: "Num Ext",
            tdClass: "text-left"
          },
          {
            key: "direccion_numint",
            label: "Num Int",
            tdClass: "text-left"
          }
        ]
      };
    },
    mounted() {
      this.checkCatalogs();
      this.mostrarCampos = 1;

    },
    created() {
      this.ip_id = this.getId();
      this.getInfLaboral();
      this.getOtro();
      // this.grupo = this.getKey('grupo');
      this.getEntes();
      this.getSectores();
      this.getPoderes();
      this.getNivelesG();
      this.getAmbitos();
      this.getFunciones();
    },

    watch: {
      n_domicilio: {
        handler: function () {
          if (this.n_domicilio) {
            this.model.direccion_encargo_pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
            this.model.direccion_encargo_entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
            this.model.direccion_encargo_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
            this.model.direccion_encargo_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
            this.model.direccion_encargo_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
            this.model.direccion_vialidad_nombre = this.n_domicilio.vialidad_nombre;
            this.model.direccion_vialidad_tipo = this.n_domicilio.vialidad;
            this.model.direccion_encargo_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
            this.model.direccion_encargo_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
            this.model.direccion_encargo_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
            this.model.domicilio_obs = this.n_domicilio.domicilio_observaciones ? this.n_domicilio.domicilio_observaciones : "";

          }
        },
        deep: true
      },
      n_domicilio2: {
        handler: function () {
          if (this.n_domicilio2) {
            this.model2.direccion_encargo_pais_id = this.n_domicilio2.pais ? this.n_domicilio2.pais : 150;
            this.model2.direccion_encargo_entidad_federativa_id = this.n_domicilio2.entidadF ? this.n_domicilio2.entidadF : "";
            this.model2.direccion_encargo_municipio_id = this.n_domicilio2.municipio ? this.n_domicilio2.municipio : "";
            this.model2.direccion_encargo_localidad_id = this.n_domicilio2.localidad ? this.n_domicilio2.localidad : "";
            this.model2.direccion_encargo_cp = this.n_domicilio2.cp ? this.n_domicilio2.cp : "";
            this.model2.direccion_vialidad_nombre = this.n_domicilio2.vialidad_nombre;
            this.model2.direccion_vialidad_tipo = this.n_domicilio2.vialidad;
            this.model2.direccion_encargo_numext = this.n_domicilio2.ext ? this.n_domicilio2.ext : "";
            this.model2.direccion_encargo_numint = this.n_domicilio2.int ? this.n_domicilio2.int : "";
            this.model2.direccion_encargo_colonia = this.n_domicilio2.colonia ? this.n_domicilio2.colonia : "";
            this.model2.domicilio_obs = this.n_domicilio2.domicilio_observaciones ? this.n_domicilio2.domicilio_observaciones : "";

          }
        },
        deep: true
      }
    },
    methods: {
      deshabilitado() {
        //CONALEP 35, simplificada es grupo 3
        // && this.getKey('grupo')==3
        if (this.getKey('ente_publico_id') == 35)
          return false
        else
          return true
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll();
      },
      showItem() {
        this.add_item = !this.add_item;
      },
      getAmbito(index) {
        var resp = "";
        if (this.ambitos) {
          this.ambitos.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getPoder(index) {
        var resp = "";
        if (this.poderes) {
          this.poderes.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getNivel(index) {
        var resp = "";
        if (this.niveles) {
          this.niveles.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getSector(index) {
        var resp = "";
        if (this.sectores && index) {
          this.sectores.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getEnte(index) {
        var resp = " ";
        if (this.entes) {
          this.entes.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      cancelEdit() {
        if (this.edit_item) {
          this.edit_item.item._rowVariant = "";
        }
        this.limpiaCampos();
        this.showItem();
        this.edit_item = null;
      },
      getInfLaboral() {
        var v = this;
        this.$http.get("encargoAct/" + this.ip_id).then(
          response => {
            if (response.data.informacion != null) {
              this.model = response.data.informacion;
              this.model.contratado_honorarios = String(
                this.model.contratado_honorarios
              );
              $.each(response.data.informacion.funcionesp, function (key, value) {
                v.funcionesArr.push(value.funcion_id);
              });
              this.model.funcionesp = v.funcionesArr;
            }
            this.editDomicilio()
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        );
      },
      getOtro() {
        var v = this;
        this.$http.get("otroEncargo/" + this.ip_id).then(
          response => {
            if (response.data.otroenc.length > 0) {
              this.model2 = response.data.otroenc[0];
              this.model2.contratado_honorarios = String(
                this.model2.contratado_honorarios
              );
              this.bandera = '1'
            }

            this.editDomicilio2()
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        );
      },
      getEntes() {
        var v = this;
        this.$http.get("cat_ente_publico").then(
          response => {
            this.entes = response.data.entes_publicos;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        );
      },
      editDomicilio() {
        if (this.model) {
          this.n_domicilio = {
            'pais_id': this.model.direccion_encargo_pais_id,
            'entidadF': this.model.direccion_encargo_entidad_federativa_id,
            'municipio': this.model.direccion_encargo_municipio_id,
            'colonia': this.model.direccion_encargo_colonia,
            'cp': this.model.direccion_encargo_cp,
            'localidad': this.model.direccion_encargo_localidad_id,
            'ext': this.model.direccion_encargo_numext,
            'int': this.model.direccion_encargo_numint,
            'vialidad': this.model.direccion_vialidad_tipo,
            'vialidad_nombre': this.model.direccion_vialidad_nombre,
            'domicilio_observaciones': this.model.domicilio_obs
          }

        }
      },
      editDomicilio2() {
        if (this.model2) {
          this.n_domicilio2 = {
            'pais_id': this.model2.direccion_encargo_pais_id,
            'entidadF': this.model2.direccion_encargo_entidad_federativa_id,
            'municipio': this.model2.direccion_encargo_municipio_id,
            'colonia': this.model2.direccion_encargo_colonia,
            'cp': this.model2.direccion_encargo_cp,
            'localidad': this.model2.direccion_encargo_localidad_id,
            'ext': this.model2.direccion_encargo_numext,
            'int': this.model2.direccion_encargo_numint,
            'vialidad': this.model2.direccion_vialidad_tipo,
            'vialidad_nombre': this.model2.direccion_vialidad_nombre,
            'domicilio_observaciones': this.model2.domicilio_obs
          }

        }
      },
      getSafe(fn, defaultVal) {
        try {
          return fn();
        } catch (e) {
          return defaultVal;
        }
      },
      showInput() {
        this.tags.inputVisible = true;
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        let inputValue = this.tags.inputValue;
        if (inputValue) {
          this.tags.dynamicTags.push(inputValue);
        }
        this.tags.inputVisible = false;
        this.tags.inputValue = "";
      },
      getPoderes() {
        this.$http.get("poderJuridico").then(
          response => {
            this.poderes = response.data.poderJuridico;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        );
      },
      getNivelesG() {
        this.$http.get("nivelGobierno").then(
          response => {
            this.niveles = response.data.nivelGobierno;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        );
        /* var unArray = [{
          id: 1,
          codigo: "EST",
          valor: "Estatal"
        }];
        this.niveles = unArray; */
      },
      getAmbitos() {
        this.$http.get("ambitos").then(
          response => {
            this.ambitos = response.data.ambitos;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        );
      },
      getSectores() {
        this.$http.get("cat_sector_industria").then(
          response => {
            this.sectores = response.data.sectores;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        );
      },
      getFunciones() {
        this.$http.get("funcPrinc").then(
          response => {
            this.funciones_p = response.data.funciones;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        );
      }
    }
  };

</script>
<style>


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Personal/EncargoActual.vue